export const TRANSACTION_NS = 'transaction';
